export const policyTypes = {
  FETCHING: "FETCHING",
  SET_HOUSE_RULES: "SET_HOUSE_RULES",
  SET_CANCELLATION_POLICY: "SET_CANCELLATION_POLICY",
  ADD_POLICY: "ADD_POLICY",
  EDIT_POLICY: "EDIT_POLICY",
};
